import { useQuery } from '@tanstack/react-query'
import { fetchMyFeed } from '@/api/feed'
import type { FeedPage } from '@/api/types'

const FIFTY_MINUTES = 50 * 60 * 1000

export const useMyFeed = (page: number, size: number = 20) =>
  useQuery<FeedPage>({
    queryKey: ['feed', page, size],
    queryFn: () => fetchMyFeed(page, size),
    // Feed cards carry hero thumbs whose signed URLs expire in ~1h. 50min staleTime keeps the
    // page fresh enough that the URLs in the rendered cards remain valid.
    staleTime: FIFTY_MINUTES,
  })
